import axios from '../utils/axios';
import Constants from './types';
import { getSessionId, getPayloadFromError, getEntityById } from '../utils';

export const getFieldValueIndexes = (entityId, theSessionId) => {
  const sessionId = theSessionId ? theSessionId : getSessionId();
  return dispatch => {
    dispatch(getFieldValueIndexesRequest());
    axios({
      method: 'get',
      url: '/openempi-ws-rest/1.0/field-value-indexes',
      headers: {
        Accept: 'application/json',
        OPENEMPI_SESSION_KEY: sessionId
      },
      params: {
        entityId
      }
    })
      .then(res => {
        dispatch(
          getFieldValueIndexesSuccess(transformFieldValueIndexes(res.data))
        );
      })
      .catch(err => {
        dispatch(getFieldValueIndexesFailure(err));
      });
  };
};

export const getFieldValueIndex = (
  entityId,
  fieldValueIndexId,
  firstResult,
  maxResults,
  theSessionId
) => {
  const sessionId = theSessionId ? theSessionId : getSessionId();
  return dispatch => {
    axios({
      method: 'get',
      url: `/openempi-ws-rest/1.0/field-value-indexes/${fieldValueIndexId}`,
      headers: {
        Accept: 'application/json',
        OPENEMPI_SESSION_KEY: sessionId
      },
      params: {
        entityId,
        firstResult,
        maxResults
      }
    })
      .then(res => {
        dispatch({
          type: Constants.FIELDVALUEINDEX_GET_SUCCESS,
          payload: transformFieldValueIndex(res.data)
        });
      })
      .catch(err => {
        const payload = getPayloadFromError(err);
        dispatch({
          type: Constants.FIELDVALUEINDEX_GET_FAILURE,
          payload
        });
      });
  };
};

export const getFieldValueIndexClusters = (
  entityId,
  fieldValueIndexId,
  filteringAlgorithm,
  threshold
) => {
  const sessionId = getSessionId();
  return dispatch => {
    dispatch(getFieldValueIndexClustersRequest());
    axios({
      method: 'get',
      url: `/openempi-ws-rest/1.0/field-value-indexes/${fieldValueIndexId}/clusters`,
      headers: {
        Accept: 'application/json',
        OPENEMPI_SESSION_KEY: sessionId
      },
      params: {
        entityId,
        param: 'n,4',
        filter: filteringAlgorithm,
        threshold: threshold
      }
    })
      .then(res => {
        dispatch(getFieldValueIndexClustersSuccess(res.data));
      })
      .catch(err => {
        dispatch(getFieldValueIndexClustersFailure(err));
      });
  };
};

export const createFieldValueIndex = (entityId, field) => {
  const sessionId = getSessionId();
  return dispatch => {
    axios({
      method: 'POST',
      url: '/openempi-ws-rest/1.0/field-value-indexes',
      headers: {
        Accept: 'application/json',
        'Content-type': 'application/json',
        OPENEMPI_SESSION_KEY: sessionId
      },
      params: {
        entityId: entityId,
        field: field
      }
    })
      .then(res => {
        dispatch(saveFieldValueIndexSuccess(res.data));
        dispatch(getFieldValueIndexes(entityId, sessionId));
      })
      .catch(err => {
        dispatch(saveFieldValueIndexFailure(err));
      });
  };
};

export const deleteFieldValueIndex = (entityId, id) => {
  const sessionId = getSessionId();
  return dispatch => {
    axios({
      method: 'DELETE',
      url: '/openempi-ws-rest/1.0/field-value-indexes/' + id,
      headers: {
        Accept: 'application/json',
        'Content-type': 'application/json',
        OPENEMPI_SESSION_KEY: sessionId
      },
      params: {
        entityId: entityId
      }
    })
      .then(res => {
        dispatch(getFieldValueIndexes(entityId, sessionId));
      })
      .catch(err => {
        dispatch(deleteFieldValueIndexFailure(err));
      });
  };
};

export const regenerateFieldValueIndex = (entityId, id) => {
  const sessionId = getSessionId();
  return dispatch => {
    axios({
      method: 'PUT',
      url: '/openempi-ws-rest/1.0/field-value-indexes/' + id,
      headers: {
        Accept: 'application/json',
        'Content-type': 'application/json',
        OPENEMPI_SESSION_KEY: sessionId
      },
      params: {
        entityId: entityId
      }
    })
      .then(res => {
        dispatch(getFieldValueIndexes(entityId, sessionId));
      })
      .catch(err => {
        dispatch(regenerateFieldValueIndexFailure(err));
      });
  };
};

const transformFieldValueIndexes = fieldValueIndexes => {
  return fieldValueIndexes.map(fieldValueIndex =>
    transformFieldValueIndex(fieldValueIndex)
  );
};

const transformFieldValueIndex = fieldValueIndex => {
  const entity = getEntityById(fieldValueIndex.entityId);
  fieldValueIndex.entity = entity ? entity.displayName : 'Unknown';
  return fieldValueIndex;
};

export const clearFieldValueIndexesError = () => {
  return {
    type: Constants.FIELDVALUEINDEXES_CLEAR_ERROR
  };
};

const getFieldValueIndexesRequest = () => {
  return {
    type: Constants.FIELDVALUEINDEXES_GET_REQUEST
  };
};

const getFieldValueIndexesSuccess = data => {
  return {
    type: Constants.FIELDVALUEINDEXES_GET_SUCCESS,
    payload: data
  };
};

const getFieldValueIndexesFailure = err => {
  if (err && err.response && err.response.status === 404) {
    return {
      type: Constants.FIELDVALUEINDEXES_NOT_FOUND
    };
  }
  const payload = getPayloadFromError(err);
  return {
    type: Constants.FIELDVALUEINDEXES_GET_FAILURE,
    payload
  };
};

const getFieldValueIndexClustersRequest = () => {
  return {
    type: Constants.FIELDVALUEINDEXCLUSTERS_GET_REQUEST
  };
};

const getFieldValueIndexClustersSuccess = data => {
  return {
    type: Constants.FIELDVALUEINDEXCLUSTERS_GET_SUCCESS,
    payload: data
  };
};

const getFieldValueIndexClustersFailure = err => {
  const payload = getPayloadFromError(err);
  return {
    type: Constants.FIELDVALUEINDEXCLUSTERS_GET_FAILURE,
    payload
  };
};

const saveFieldValueIndexSuccess = data => {
  return {
    type: Constants.FIELDVALUEINDEXES_SAVE_SUCCESS,
    payload: data
  };
};

const saveFieldValueIndexFailure = err => {
  const payload = getPayloadFromError(err);
  return {
    type: Constants.FIELDVALUEINDEXES_SAVE_FAILURE,
    payload
  };
};

const regenerateFieldValueIndexFailure = err => {
  const payload = getPayloadFromError(err);
  return {
    type: Constants.FIELDVALUEINDEXES_REGEN_FAILURE,
    payload
  };
};

const deleteFieldValueIndexFailure = err => {
  const payload = getPayloadFromError(err);
  return {
    type: Constants.FIELDVALUEINDEXES_SAVE_FAILURE,
    payload
  };
};
